import axios from 'axios';

   const axiosInstance = axios.create({
     baseURL: 'https://driveeasy-portal-904892438797.asia-south1.run.app',
     headers: {
       'Content-Type': 'application/json',
     },
   });

   // Fetch all school owners
   export const getSchoolOwners = async (page = 1, limit = 10, filters = {}, sort = 'createdAt', order = 'desc') => {
     try {
       const response = await axiosInstance.get('/drveasy/drivingschools', {
         params: {
           page,
           limit,
           ...filters,
           sort,
           order,
         },
       });
       return response.data;
     } catch (error) {
       console.error('Error fetching school owners:', error);
       throw error;
     }
   };

   export const updateApprovalStatus = async (uid, newStatus) => {
     try {
       const response = await axiosInstance.post('/drveasy/verifySchool', {
         uid,
         approvalStatus: newStatus,
       });
       return response.data;
     } catch (error) {
       console.error('Error updating approval status:', error);
       throw error;
     }
   };

   // Fetch all instructors
   export const getInstructors = async (page = 1, limit = 10, filters = {}, sort = 'createdAt', order = 'desc') => {
     try {
       const response = await axiosInstance.get('/drveasy/instructors', {
         params: {
           page,
           limit,
           ...filters,
           sort,
           order,
         },
       });
       return response.data;
     } catch (error) {
       console.error('Error fetching instructors:', error);
       throw error;
     }
   };

   export const updateApprovalStatusInstructor = async (instructorId, newStatus) => {
        try {
          const response = await axiosInstance.post('/drveasy/verifyInstructor', {
            instructorId,
            approvalStatus: newStatus,
          });
          return response.data;
        } catch (error) {
          console.error('Error updating approval status:', error);
          throw error;
        }
      };

   // Fetch all students
  export const getStudents = async (page = 1, limit = 10, filters = {}, sort = 'createdAt', order = 'desc') => {
    try {
      const response = await axiosInstance.get('drveasy/students', {
        params: {
          page,
          limit,
          ...filters,
          sort,
          order,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching students:', error);
      throw error;
    }
  };

  export const getCourses = async () => {
    const response = await axiosInstance.get('/drveasy/courses');
    return response.data;
  };

  export const getBookings = async () => {
    const response = await axiosInstance.get('/drveasy/bookings');
    return response.data;
  };

  export const getPayments = async () => {
    const response = await axiosInstance.get('/drveasy/payments');
    return response.data;
  };

  export const getCars = async () => {
    const response = await axiosInstance.get('/drveasy/cars');
    return response.data;
  };

  export const updateApprovalStatusCar = async (carId, newStatus) => {
      try {
        const response = await axiosInstance.post('/drveasy/verifyCar', {
          carId,
          approvalStatus: newStatus,
        });
        return response.data;
      } catch (error) {
        console.error('Error updating approval status:', error);
        throw error;
      }
    };

    export const getExpansionAndroid = async () => {
      const { data } = await axiosInstance.get('/drveasy/expansionAndroid'); // your endpoint
      // Expect array of docs (address, createdAt, selectedDate, selectedTimeSlot, studentId, studentName, phoneNumber)
      return data || [];
    };

    export const getExpansionIOS = async () => {
      const { data } = await axiosInstance.get('/drveasy/expansionIos'); // your endpoint
      return data || [];
    };

   export default axiosInstance;